import Reveal from '@/components/feature/Reveal';
import { services, extraNote } from '@/mocks/services';

export default function Services() {
  return (
    <section id="leistungen" className="relative bg-background-100 py-20 md:py-28 scroll-mt-24">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-2xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.32em] text-primary-600">
            <span className="w-6 h-px bg-accent-500" />
            Unsere Leistungen
            <span className="w-6 h-px bg-accent-500" />
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-tight text-foreground-950">
            Alles rund um Ihren Garten – aus einer Hand
          </h2>
          <p className="mt-5 font-body text-base md:text-lg leading-relaxed text-foreground-600">
            Von der laufenden Pflege über fachgerechte Baumpflege bis zur kompletten Neuanlage:
            Wir übernehmen alles – professionell und zuverlässig.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service, index) => (
            <Reveal key={service.id} delay={index * 90} className="h-full">
              <article className="group h-full flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-500 hover:-translate-y-1.5 hover:border-accent-300 hover:shadow-[0_30px_70px_-40px_oklch(var(--primary-950)/0.45)]">
                {/* Image */}
                <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                  <img
                    src={service.image}
                    alt={`${service.title} – ${service.intro}`}
                    title={`${service.title} | Arnold Gartenpflege`}
                    className="w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-[1.08]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/55 via-transparent to-transparent" />
                  <span className="absolute top-4 left-4 w-11 h-11 rounded-md bg-background-50/95 backdrop-blur-sm flex items-center justify-center">
                    <i className={`${service.icon} text-xl text-primary-600`} />
                  </span>
                </div>

                {/* Body */}
                <div className="flex flex-col flex-1 p-6 md:p-7">
                  <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                    {service.title}
                  </h3>
                  <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
                    {service.intro}
                  </p>
                  <ul className="mt-5 space-y-2.5 border-t border-background-200 pt-5">
                    {service.items.map((item) => (
                      <li key={item} className="flex items-start gap-2.5">
                        <i className="ri-check-line mt-0.5 text-accent-600 text-base shrink-0" />
                        <span className="font-body text-sm text-foreground-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        {/* Striking banner: Eigentümerwechsel */}
        <Reveal className="mt-8 md:mt-10">
          <div className="grid lg:grid-cols-2 overflow-hidden rounded-2xl border border-primary-900 bg-primary-950">
            <div className="relative order-1 lg:order-2 min-h-[260px] lg:min-h-full">
              <img
                src={extraNote.image}
                alt="Gepflegtes Einfamilienhaus mit sauberem Vorgarten vor dem Immobilienverkauf"
                title="Gartenpflege vor Immobilienverkauf | Arnold Gartenpflege"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent lg:bg-gradient-to-r lg:from-primary-950 lg:via-primary-950/30 lg:to-transparent" />
            </div>

            <div className="order-2 lg:order-1 p-8 md:p-10 flex flex-col justify-center">
              <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent-500 px-3.5 py-1.5 font-label text-xs font-bold uppercase tracking-wider text-foreground-950">
                <i className="ri-home-smile-2-line text-base" />
                Immobilien &amp; Eigentümerwechsel
              </span>
              <h3 className="mt-5 font-heading text-2xl md:text-3xl font-semibold leading-tight text-background-50">
                {extraNote.title}
              </h3>
              <p className="mt-4 font-body text-sm md:text-base leading-relaxed text-background-100/80">
                {extraNote.text}
              </p>
              <ul className="mt-6 space-y-3">
                {extraNote.points.map((point) => (
                  <li key={point} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill mt-0.5 text-accent-400 text-lg shrink-0" />
                    <span className="font-body text-sm font-medium text-background-100">{point}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#kontakt"
                className="mt-8 inline-flex w-fit items-center justify-center gap-2 rounded-md bg-accent-500 hover:bg-accent-400 text-foreground-950 font-label font-bold text-base px-7 py-4 transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line text-lg" />
                Jetzt anfragen
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}